import articleConfig from 'article/config'
import ArticleListColumnModel from '../../../modules/article/components/list/models/article-list-column-model'
import { sanitizeListColumns } from '../../util/sanitizeListColumns'
import request from '@/modules/base/util/request'

// actions
const FINSIHED_FETCHING_ARTICLE_LIST_SETTING = 'FINSIHED_FETCHING_ARTICLE_LIST_SETTING'
const ERROR_FETCHING_ARTICLE_LIST_SETTING = 'ERROR_FETCHING_ARTICLE_LIST_SETTING'
const SHOW_ARTICLES_LOADER = 'SHOW_ARTICLES_LOADER'
const HIDE_ARTICLES_LOADER = 'HIDE_ARTICLES_LOADER'
const SET_ARTICLE_LIST_ITEMS = 'SET_ARTICLE_LIST_ITEMS'
const SET_ARTICLE_PAGINATION = 'SET_ARTICLE_PAGINATION'
const SET_ARTICLE_SEARCH_TERM = 'SET_ARTICLE_SEARCH_TERM'
const REFRESH_ARTICLES = 'REFRESH_ARTICLES'
const STOP_REFRESHING_ARTICLES = 'STOP_REFRESHING'

// reducer
const initialState = {
  isLoading: true,
  error: null,
  items: [],
  setting: {
    columns: [],
  },
  searchTerm: '',
  pagination: {
    offset: 0, // current starting point in list
    count: 0, // count of filtered articles
    totalCount: 0, // count of all articles
    limit: 20, // max articles on page
  },
  shouldRefresh: false,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FINSIHED_FETCHING_ARTICLE_LIST_SETTING:
      const { setting } = action
      return Object.assign({}, state, {
        error: null,
        setting,
      })

    case SHOW_ARTICLES_LOADER:
      return Object.assign({}, state, {
        isLoading: true,
      })

    case HIDE_ARTICLES_LOADER:
      return Object.assign({}, state, {
        isLoading: false,
      })

    case SET_ARTICLE_LIST_ITEMS:
      const { articles } = action
      return Object.assign({}, state, {
        items: articles,
      })

    case SET_ARTICLE_PAGINATION:
      const { pagination } = action
      const updatedPagination = Object.assign({}, state.pagination, pagination)
      return Object.assign({}, state, { pagination: updatedPagination })

    case SET_ARTICLE_SEARCH_TERM:
      const { searchTerm } = action
      return Object.assign({}, state, {
        searchTerm,
      })

    case REFRESH_ARTICLES:
      return Object.assign({}, state, {
        shouldRefresh: true,
      })

    case STOP_REFRESHING_ARTICLES:
      return Object.assign({}, state, {
        shouldRefresh: false,
      })

    case ERROR_FETCHING_ARTICLE_LIST_SETTING:
      const { error } = action
      return Object.assign({}, state, {
        isLoading: false,
        error,
      })

    default:
      return state
  }
};

// action creators
export const showLoader = () => {
  return {
    type: SHOW_ARTICLES_LOADER,
  }
}

export const hideLoader = () => {
  return {
    type: HIDE_ARTICLES_LOADER,
  }
}

export const setArticleListItems = (articles) => {
  return {
    type: SET_ARTICLE_LIST_ITEMS,
    articles,
  }
}

export const refreshList = () => {
  return {
    type: REFRESH_ARTICLES,
  }
}

export const stopRefreshingList = () => {
  return {
    type: STOP_REFRESHING_ARTICLES,
  }
}

export const setPagination = (pagination) => {
  return {
    type: SET_ARTICLE_PAGINATION,
    pagination,
  }
}

export const setSearchTerm = (searchTerm) => {
  return {
    type: SET_ARTICLE_SEARCH_TERM,
    searchTerm,
  }
}

const finishedFetchingArticleListSetting = (setting) => {
  return {
    type: FINSIHED_FETCHING_ARTICLE_LIST_SETTING,
    setting,
  }
}

const errorFetchingArticleListSetting = (error) => {
  return {
    type: ERROR_FETCHING_ARTICLE_LIST_SETTING,
    error,
  }
}

export const fetchArticleListSetting = () => {
  return (dispatch) => {
    request(articleConfig.articleListSetting, { auth: true, isConcurrent: true })
      .then((response) => {
        const {
          body: {
            data: { columns, isSmallBusiness },
            meta: {
              defaultSort,
              sortBy,
            },
          },
        } = response

        const sanitizedColumns = sanitizeListColumns(columns, defaultSort, sortBy)
        const articleColumns = sanitizedColumns.map((column) => {
          column.displayed = true

          if (column.name === 'priceNet' || column.name === 'priceGross') {
            column.active = !isSmallBusiness
            column.displayed = !isSmallBusiness
          }
          if (column.name === 'price') {
            column.active = isSmallBusiness
            column.displayed = isSmallBusiness
          }

          return new ArticleListColumnModel(column)
        })

        dispatch(finishedFetchingArticleListSetting({ columns: articleColumns }))
      })
      .catch((error) => {
        dispatch(errorFetchingArticleListSetting(error))
      })
  }
}
